import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorBookingItemSettingEligibility } from '../editor-booking-item-setting/editor-booking-item-setting-eligibility.model';


@Component({
    selector: 'eas-editor-booking-item-setting-summary-eligibility',
    templateUrl: './editor-booking-item-setting-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingSummaryEligibilityComponent implements OnInit {
  @Input() itemSetting: EditorBookingItemSettingEligibility;
  @Input() first: boolean;
  @Input() last: boolean;

  private destroyed$ = new Subject<void>();

  eligibilityRulesNames: { id: string, name: string }[];

  summary: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.eligibilityRulesNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(eligibilityRulesNames => {
        this.eligibilityRulesNames = eligibilityRulesNames;
        this.summary = this.getSummary();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      if (this.eligibilityRulesNames !== undefined) {
        this.summary = this.getSummary();
      }
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getSummary(): string {
    let summary = this.itemSetting.getIdAsString(this.eligibilityRulesNames);

    if (summary === '') {
      return summary;
    }

    summary = this.first ? summary.charAt(0).toUpperCase() + summary.slice(1) : summary;
    if (!this.last) {
      summary = `${summary}, `;
    }

    return summary;
  }
}
